module.exports = __webpack_public_path__ + "img/moishop_portfolio_3_2x.84c08200.png";